module.exports = __webpack_public_path__ + "static/media/DSC09118_20180710_018-4.522f4d99.jpg";